var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.784,
    height: 12.79,
    viewBox: "0 0 17.784 12.79",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun-email-4554864",
    transform: "translate(-2.979 -6.355)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3495",
    "data-name": "Group 3495",
    transform: "translate(2.979 6.355)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32312",
    "data-name": "Path 32312",
    d: "M12.862,12.317l7.375-5.681a1.761,1.761,0,0,0-.954-.281H5.08a1.707,1.707,0,0,0-.9.252L11.5,12.317A1.09,1.09,0,0,0,12.862,12.317Z",
    transform: "translate(-3.291 -6.355)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32313",
    "data-name": "Path 32313",
    d: "M3.022,8.335C3,8.415,2.9,17.975,3.1,18.484L8.77,12.825Z",
    transform: "translate(-2.979 -6.87)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32314",
    "data-name": "Path 32314",
    d: "M12.28,16.449a2.925,2.925,0,0,1-1.923-.814l-5.8,5.807a1.576,1.576,0,0,0,.621.118h14.2a1.624,1.624,0,0,0,.429-.059l-5.748-5.748A2.674,2.674,0,0,1,12.28,16.449Z",
    transform: "translate(-3.39 -8.77)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32315",
    "data-name": "Path 32315",
    d: "M24.9,8.425l-5.9,4.542,5.726,5.726C25.036,18.085,24.91,8.5,24.9,8.425Z",
    transform: "translate(-7.151 -6.894)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.63b58d4864fcc22c19b0c65879344db0.svg";
export { ForwardRef as ReactComponent };